import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nChild } from '@web-frontend/shared/i18n';
import { DeleteBySelectionModalComponent } from './delete-by-selection-modal.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [DeleteBySelectionModalComponent],
  imports: [CommonModule, I18nChild, MatDialogModule],
  exports: [DeleteBySelectionModalComponent],
})
export class DeleteBySelectionModalModule {}
